import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { type SxProps, type Theme } from '@mui/material/styles';

export const profileFormFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    minHeight: 52,
    borderRadius: '8px',
    bgcolor: '#fff',
    '& fieldset': {
      borderColor: '#D4DEE7',
    },
    '&:hover fieldset': {
      borderColor: '#BCCBD7',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#52B2D7',
    },
    '& input': {
      fontSize: '0.9rem',
      color: '#1A2530',
      paddingTop: '12px',
      paddingBottom: '12px',
    },
    '& textarea': {
      fontSize: '0.9rem',
      color: '#1A2530',
    },
    '& .MuiSelect-select': {
      fontSize: '0.9rem',
      color: '#1A2530',
      paddingTop: '12px',
      paddingBottom: '12px',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#6E7E89',
    fontSize: '0.8rem',
    '&.Mui-focused': {
      color: '#4D5A65',
    },
  },
  '& .MuiInputLabel-shrink': {
    px: '4px',
    width: 'fit-content',
    maxWidth: 'calc(100% - 24px)',
    bgcolor: '#fff',
    // Move floating labels slightly down to align better with outlined notches.
    transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
    mx: 0,
    mt: 0.65,
    color: '#6A7784',
    fontSize: '0.76rem',
    lineHeight: 1.35,
  },
  '& .MuiFormHelperText-root.Mui-disabled': {
    color: '#9AA7B3',
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: '#d32f2f',
  },
};

type ProfileFormFieldProps = TextFieldProps;

export const ProfileFormField = ({ sx, InputLabelProps, ...props }: ProfileFormFieldProps) => (
  <TextField
    fullWidth
    variant="outlined"
    InputLabelProps={{ shrink: true, ...InputLabelProps }}
    sx={Array.isArray(sx) ? [profileFormFieldSx, ...sx] : [profileFormFieldSx, sx]}
    {...props}
  />
);
